import type { CSSProperties } from "react";

import componentsConfig from "../../components.json";

type ThemeCssVars = CSSProperties & Record<`--${string}`, string | number>;

export const shadcnTheme = {
  style: componentsConfig.style,
  baseColor: componentsConfig.tailwind.baseColor,
  cssFile: componentsConfig.tailwind.css,
  cssVariables: componentsConfig.tailwind.cssVariables,
  iconLibrary: componentsConfig.iconLibrary,
  primitiveBase: "radix",
} as const;

export const elenailsTheme = {
  name: "elenails-liquid-glass",
  headerHeight: {
    desktop: "76px",
    mobile: "68px",
  },
  colors: {
    surface: "var(--surface)",
    ink: "var(--ink)",
    muted: "var(--muted)",
    line: "var(--line)",
    accent: "var(--accent)",
    accentSoft: "var(--accent-soft)",
    deep: "var(--deep)",
    cream: "var(--cream)",
  },
  radius: {
    token: "var(--radius)",
    pill: "999px",
    accountMenu: "15px",
  },
  styles: {
    glassVars: {
      "--liquid-glass-tint": "rgba(46, 28, 54, 0.62)",
      "--liquid-glass-tint-strong": "rgba(159, 120, 176, 0.18)",
      "--liquid-glass-tint-soft": "rgba(255, 207, 232, 0.07)",
      "--liquid-glass-rim": "rgba(255, 223, 245, 0.38)",
      "--liquid-glass-rim-soft": "rgba(204, 158, 220, 0.18)",
      "--liquid-glass-shadow": "0 26px 62px rgba(24, 9, 31, 0.34), 0 9px 24px rgba(75, 38, 86, 0.22)",
      "--liquid-glass-inner-shadow": "inset 0 1px 0 rgba(255, 255, 255, 0.34), inset 0 -1px 0 rgba(255, 255, 255, 0.08)",
      "--liquid-glass-blur": "42px",
      "--liquid-glass-saturate": "210%",
      "--liquid-glass-highlight": "rgba(255, 255, 255, 0.14)",
      "--liquid-glass-active": "rgba(213, 166, 232, 0.18)",
    } as ThemeCssVars,
    headerGlassVars: {
      "--liquid-glass-tint": "rgba(75, 45, 88, 0.24)",
      "--liquid-glass-tint-strong": "rgba(255, 223, 245, 0.18)",
      "--liquid-glass-tint-soft": "rgba(149, 101, 171, 0.16)",
      "--liquid-glass-rim": "rgba(255, 239, 250, 0.48)",
      "--liquid-glass-rim-soft": "rgba(204, 158, 220, 0.20)",
      "--liquid-glass-shadow": "0 14px 42px rgba(39, 17, 49, 0.08)",
      "--liquid-glass-inner-shadow": "inset 0 1px 0 rgba(255, 255, 255, 0.42), inset 0 -1px 0 rgba(46, 20, 58, 0.08)",
      "--liquid-glass-blur": "38px",
      "--liquid-glass-saturate": "210%",
      "--liquid-glass-highlight": "rgba(255, 235, 249, 0.26)",
      "--liquid-glass-active": "rgba(213, 166, 232, 0.24)",
    } as ThemeCssVars,
  },
  menu: {
    accountSideOffset: 28,
    accountSubSideOffset: 8,
    accountSubAlignOffset: -8,
    collisionPadding: 12,
    mobileSideOffset: 26,
    mobileSubSideOffset: 6,
    mobileSubAlignOffset: 0,
    mobileCollisionPadding: 18,
  },
  classes: {
    header: "site-header mira-compact-header",
    accountActions: "header-account-actions",
    accountTrigger: "header-my-bookings header-account-trigger",
    menuSurface: "liquid-glass-menu",
    accountMenu: "header-menu-content",
    accountSubMenu: "liquid-glass-menu account-menu-sub-content",
    accountSubTrigger: "account-menu-sub-trigger",
    accountIdentity: "account-menu-identity",
    accountSectionLabel: "account-menu-section-label",
    accountLogout: "account-menu-logout",
    mobileMenu: "liquid-glass-menu mobile-menu-content",
    mobileSubMenu: "liquid-glass-menu account-menu-sub-content mobile-menu-sub-content",
    mobileSubTrigger: "account-menu-sub-trigger mobile-menu-sub-trigger",
    mobileMenuLabel: "mobile-menu-section-label",
    themeToggle: "header-theme-trigger",
    // Theme choices intentionally use the exact same surface as the account menu.
    themeToggleMenu: "header-menu-content",
    themeToggleLabel: "theme-switcher-label",
  },
} as const;

export type ShadcnTheme = typeof shadcnTheme;
export type ElenailsTheme = typeof elenailsTheme;
